module.exports = __webpack_public_path__ + "images/emoji/clock730.7632d92520ef520ce4ac.png";